import React, { FC, useState } from "react";
import { Dropdown, Space, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { LotTransactionDetailItems, LotTransactionDetailResponse } from "services/interface";
import { formatDate } from "utils/dateFormat";

const columns: ColumnsType<LotTransactionDetailItems> = [
  {
    title: "จังหวัด",
    dataIndex: "province_name",
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "ชื่อศูนย์กระจายสินค้า",
    dataIndex: "dc_name",
    render: (text) => {
      return <div>{text ? text : "-"}</div>;
    },
  },
  {
    title: "สินค้า",
    dataIndex: "product_name",
    render: (_text, record) => {
      return <div style={{ display: "flex", flexDirection: "row" }}>
      <img
        src={record.sku_image}
        alt={record.sku_image}
        style={{ width: 40, height: 40, marginRight: 10 }}
      />
      <div style={{ maxWidth: '150px', overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>        
        <Typography.Paragraph style={{marginBottom:0}}>{record.product_name}</Typography.Paragraph>
        <Typography.Paragraph style={{fontSize:"10px",marginBottom:0}}>{record.sku_name}</Typography.Paragraph>
      </div>
    </div>
      ;
    },
  },
  {
    title: "หมายเลขออเดอร์",
    dataIndex: "order_code",
    render: (_text) => {
      return <Typography.Paragraph>{_text}</Typography.Paragraph>;
    },
  },
  {
    title: "วันที่จัดส่ง",
    dataIndex: "transection_date",
    render: (_text) => {
      return <div>{formatDate(_text)}</div>;
    },
  },
  {
    title: "จำนวน",
    dataIndex: "order_qty",
  }
];
//

interface TableOrderListProps {
  id: string;
  data: LotTransactionDetailResponse | undefined;
  offset: any;
  limit: any;
  setOffset: any;
  setLimit: any;
}
const TableOrderList: FC<TableOrderListProps> = ({ id, data, offset, limit, setOffset, setLimit }) => {

  return (
    <div>
      <Table 
      // rowSelection={rowSelection} 
      columns={columns} 
      dataSource={data?.data?.row_data}
      pagination={{
        pageSize: limit,
        total: parseInt(data?.data?.total_record as string) ,
        onChange: (page, pageSize) => {
          setOffset(pageSize! * (page! - 1));
          setLimit(pageSize!);
        },
      }}
       />
    </div>
  );
};

export default TableOrderList;
